// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
// import uuid from "react-native-uuid";
import { Loader, Toastr, Button } from "@revvsales/components";
import { isValidPhoneNumber } from "react-phone-number-input";

// Components Imports
import SignerListSection from "./AddRecipientsPopup/SignerListSection";
import SignerListSectionForm from "./AddRecipientsPopup/SignerListSectionForm";
import SHIELD from "../../assets/ic-shield.svg";

// Action Imports
import {
  addDocRecipientsAction,
  fetchDocRecipientListAction,
  sendForSignatureV2,
  tempUpdateDocMeta,
} from "../../actions/DocumentActions";

// Internal Imports
import { DocumentUtils, AmplitudeUtils, GlobalUtils } from "../../utils";
import { EVENTS } from "../../constants";

const { amplitudeLogEvent } = AmplitudeUtils;
const { handleApiErrMsg } = GlobalUtils;
const { getExportContent } = DocumentUtils;

class SignerListPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: "",
      signersList: [],
      showLoader: false,
      fillersList: [],
      isTrue: false,
      fillerMessgae: false,
      docepientEmailMessage: "",
    };
  }

  componentDidMount() {
    this._fetchSharedReviewerList();
  }

  _closePopup = () => {
    this.props.toggleModalPopUp("showSignerListPopup", false);
  };

  _toggleCheckbox = i => {
    let data = [];
    let ButtonDisable = false;
    data = [...this.state.signersList];
    data[i].showOtp = !data[i].showOtp;
    // data[i].isPossible = false;
    if (data[i].showOtp) {
      ButtonDisable = true;
    }
    this.setState(() => ({ signersList: data, isTrue: ButtonDisable }));
  };

  _fetchSharedReviewerList = () => {
    const { document } = this.props;
    this.setState({
      showLoader: true,
    });
    this.props
      .fetchDocRecipientList(document.id)
      .then(response => {
        const { collaborators } = response;
        const data = [...collaborators];
        // Add the Signers and Default reviewer
        this._addSignerAndRecipientList(data);
      })
      .catch(() => {
        this._addSignerAndRecipientList([]);
        this.setState({
          showLoader: false,
        });
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _getDocumentHtml = () => {
    const documentSectionHTML = document.getElementsByClassName(
      "document-view-main-container",
    )[0];
    const html =
      documentSectionHTML && documentSectionHTML.innerHTML.length > 0
        ? documentSectionHTML.innerHTML
        : "";
    return html;
  };

  _onSendDocument = () => {
    const payload = this._getShareDocumentPayload();
    if (
      this.props.document.fields_used &&
      this.props.document.fields_used.length > 0
    ) {
      const newFiller = [];
      this.props.document.fields_used.forEach(element => {
        if (element.filler_type === "RECIPIENT") {
          newFiller.push(element);
        }
      });
      if (newFiller && newFiller.length > 0) {
        this.setState({ isTrue: true });
        if (payload.fillers && payload.fillers.length > 0) {
          this.setState({ isTrue: false });
        } else {
          this.setState({ fillerMessgae: true, isTrue: true });
          return;
        }
      }
    }
    this.setState({ showbtnLoader: true });
    this.props
      .addDocRecipientsAction(this.props.document.id, payload, "isSigner")
      .then(() => {
        if (
          payload.signers &&
          Array.isArray(payload.signers) &&
          payload.signers.length > 0
        ) {
          this._handleSendForSignature();
        } else {
          this.props.updateMultipleState({
            buttonValue: "eSign",
            showSignerListPopup: false,
            showDocStatusUpdateModal: true,
          });
        }
      })
      .catch(err => {
        if (err.response.status === 400) {
          this.props.tempUpdateDocMeta({ docIsLocked: false, stage: "DRAFT" });
        }
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
        amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_SENT_FOR_SIGNATURE, {
          Error: "Oops! Something went wrong. Please try again later.",
        });
        this.setState({ showbtnLoader: false });
        // this._closePopup();
        console.error(`SignerListPopup.js => _onSendDocument => ${err}`);
      });
  };

  _handleSendForSignature = () => {
    // const {
    //   id: documentID,
    //   template_id: templateID,
    //   documentStatus,
    //   documentTag,
    // } = this.props.document;
    // this.props
    //   .sendForSignatureV2(documentID)
    //   .then(() => {
    //     amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_SENT_FOR_SIGNATURE, {
    //       documentID,
    //       templateID,
    //       status: documentStatus ? documentStatus.name : null,
    //       tag: documentTag ? documentTag.name : null,
    //     });
    this.props.updateMultipleState({
      buttonValue: "eSign",
      showSignerListPopup: false,
      showDocStatusUpdateModal: true,
    });
    //   })
    //   .catch(() => {
    //     Toastr.showToastr({
    //       className: "is-failure",
    //       message: "Oops! Something went wrong. Please try again later.",
    //       timeout: 3000,
    //     });
    //     amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_SENT_FOR_SIGNATURE, {
    //       Error: "Oops! Something went wrong. Please try again later.",
    //     });
    //   });
  };

  _addRemoveFiller = (shouldAdd, filler) => {
    const { fillersList } = this.state;
    if (shouldAdd) {
      this.setState({
        fillersList: [...fillersList, filler],
        isTrue: false,
        fillerMessgae: false,
      });
    } else {
      this.setState({
        fillersList: fillersList.filter(
          user => user.user_email !== filler.user_email,
        ),
        isTrue: false,
        fillerMessgae: false,
      });
    }
  };

  _getShareDocumentPayload = () => {
    const { signersList, fillersList, docepientEmailMessage } = this.state;
    // Content for PDF
    const previewContent = getExportContent(
      this.props.document,
      this.props.components,
    );
    const signers = [];
    if (signersList.length > 0) {
      signersList.forEach((signer, i) => {
        signers.push({
          user_email: signer.user_email,
          first_name: signer.first_name,
          last_name: signer.last_name,
          recipientId: i + 1,
          mobile_number: signer.mobile_number,
          auth_type: signer.auth_type,
        });
      });
    }

    const data = {
      signers: [...signers],
      fillers: fillersList,
      emailSubject: "",
      isReview: false,
      isEsign: true,
      esignType: "OS", // This is hard coded for now since we support only one esignature tool
      pdfFile: {},
      email_message: docepientEmailMessage.trim(),
    };
    data.pdfFile = previewContent;
    data.pdfFile.content.schema_version = "1.0";
    data.docName = this.props.document.name;
    data.pdfFile.content.htmlString = this._getDocumentHtml();
    data.pdfFile.content.signers = signers.reduce((accum, item) => {
      accum[item.user_email] = item;
      return accum;
    }, {});
    return data;
  };

  _addSignerAndRecipientList = () => {
    const signers = this._getSignerList();
    this.setState({
      showLoader: false,
      signersList: signers,
    });
  };

  showMenu = (event, i) => {
    event.preventDefault();
    let data = [];
    data = [...this.state.signersList];
    data[i].showAuth = !data[i].showAuth;
    // data[i].showOtp = false;
    this.setState(() => ({ signersList: data }));
  };

  // Get the signer list form the document => content => sections
  _getSignerList = () => {
    const { fetchSignersList } = this.props;
    const signers = [];
    if (fetchSignersList && fetchSignersList.length > 0) {
      fetchSignersList.forEach(d => {
        const findSigner = signers.find(
          signer => signer.user_email === d.signerEmail,
        );
        if (!findSigner) {
          signers.push({
            user_email: d.signer_email,
            first_name: d.first_name,
            last_name: d.last_name,
            image_url: d.signer_config.image_url,
            role: "SIGNER",
          });
        }
      });
    }
    return signers;
  };

  numberValidation = (value, i) => {
    let ButtonTrue = true;
    let data = [];
    data = [...this.state.signersList];
    if (value && isValidPhoneNumber(value)) {
      data[i].isPossible = true;
      ButtonTrue = false;
    } else {
      data[i].isPossible = false;
      ButtonTrue = true;
    }
    this.setState(() => ({ signersList: data, isTrue: ButtonTrue }));
  };

  handlePhoneNumber = (event, i) => {
    let data = [];
    data = [...this.state.signersList];
    this.numberValidation(event, i);
    data[i].mobile_number = event;
    data[i].auth_type = "SMS";
    this.setState(() => ({ signersList: data }));
  };

  _editDocumentUpdate = () => {
    const { id: documentID } = this.props.document;
    this.props.editDocument(documentID);
    this._closePopup();
  };

  _handleDocrecipientMessageChange = e => {
    this.setState({
      docepientEmailMessage: e.target.value,
    });
  };

  _renderSignerListSection = () => {
    const { signersList } = this.state;
    if (signersList && signersList.length > 0) {
      const { document } = this.props;
      const newFiller = [];
      document.fields_used.forEach(element => {
        if (element.filler_type === "RECIPIENT") {
          newFiller.push(element);
        }
      });
      if (document.showForm && newFiller.length > 0) {
        return (
          <SignerListSectionForm
            fieldsUsed={document.fields_used}
            signersList={signersList}
            addRemoveFiller={this._addRemoveFiller}
            showMenu={this.showMenu}
            handlePhoneNumber={this.handlePhoneNumber}
            toggleCheckbox={this._toggleCheckbox}
            fillerMessgae={this.state.fillerMessgae}
          />
        );
      }
      return (
        <SignerListSection
          signersList={signersList}
          showMenu={this.showMenu}
          handlePhoneNumber={this.handlePhoneNumber}
          toggleCheckbox={this._toggleCheckbox}
        />
      );
    }

    return null;
  };

  render() {
    const { showLoader, showbtnLoader, docepientEmailMessage } = this.state;

    const errMsgSpace =
      this.state.errMsg !== "" ? (
        <div
          className="error-message-wrapper docsharingpopup-errormg-wrapper"
          data-test="doc-sharing-popup-error-message">
          {this.state.errMsg}
        </div>
      ) : null;

    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        {/* ----------- Loader Section ----------- */}
        {(showLoader || showbtnLoader) && (
          <Loader
            className="loader-bg-color"
            label={` ${
              showbtnLoader
                ? "🔏 Processing your document for eSignature."
                : "Loading..."
            }`}
          />
        )}
        <div className="docrecipientspopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div
            className="modal-heading"
            data-test="addrecipientspopup-modal-heading">
            All recipients below can sign the document
          </div>

          {errMsgSpace}

          {/* ----------- Added Signer List Section ----------- */}
          {this._renderSignerListSection()}

          {/* ------------ Personalise Email ---------- */}
          <div className="docrecipientpopup-personalise">
            <p className="docrecipientpopup-personalise-subheading">
              Personalise the email by adding a text message from you
            </p>
            <div className="docrecipientpopup-personalise-body">
              <textarea
                rows="5"
                value={docepientEmailMessage}
                onChange={this._handleDocrecipientMessageChange}
                data-test="docrecipientpopup-personalise-textarea"
                placeholder="Start typing your message here"
              />
            </div>
          </div>

          <div className="emptysigner-popup-warning-section">
            <div>
              <img src={SHIELD} alt="Revv" className="legal-signer-icon" />
            </div>
            <div>
              <div className="emptysigner-popup-legal-title">
                Legal, secure, reliable
              </div>
              <div className="emptysigner-popup-legal-subtitle">
                All documents sent for eSignature via Revv are in compliance
                with global e-signature laws.
              </div>
            </div>
          </div>
          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              id="addrecipientspopup-cancle-btn"
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="addrecipientspopup-cancle-btn"
              onClick={this._editDocumentUpdate}
              // onKeyPress={this._closePopup}>
            >
              Edit document
            </Button>

            <Button
              disabled={this.state.isTrue}
              id="addrecipientspopup-share-btn"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="addrecipientspopup-share-btn"
              isLoading={showbtnLoader}
              onClick={this._onSendDocument}>
              Send for eSign
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document, components } = state.DocumentStore;

  return {
    components,
    document,
  };
};

const mapDispatchToProps = {
  addDocRecipientsAction,
  fetchDocRecipientList: fetchDocRecipientListAction,
  sendForSignatureV2,
  tempUpdateDocMeta,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignerListPopup);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/SignerListPopup.js